import { genComponentStyleHook, type FullToken } from '../geek/styleUtil'
import { cyan, glowMd } from './glowUtil'
import { DOT_PREFIX } from './constant'

const transition = 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)'

export default genComponentStyleHook(['Card', 'techTheme'], (token: FullToken) => {
  const { componentCls } = token

  return {
    [`${componentCls}${DOT_PREFIX}`]: {
      transition,
      borderRadius: 4,
      overflow: 'hidden',
      position: 'relative' as const,
      backdropFilter: 'blur(20px) saturate(180%)',
      WebkitBackdropFilter: 'blur(20px) saturate(180%)',
      background: 'rgba(15, 23, 42, 0.82)',
      border: `1px solid ${cyan[500]}20`,
      boxShadow: `0 0 1px ${cyan[500]}40`,

      '&:hover': {
        borderColor: `${cyan[500]}40`,
        boxShadow: glowMd,
      },

      '&:before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        height: 1,
        background: `linear-gradient(90deg, transparent, ${cyan[500]}60, transparent)`,
        opacity: 0.6,
        transition,
        pointerEvents: 'none',
      },

      [`${componentCls}-head`]: {
        borderBottom: `1px solid ${cyan[500]}12`,
        background: `${cyan[500]}04`,

        [`${componentCls}-head-title`]: {
          color: `${cyan[200]} !important`,
          fontWeight: 600,
          letterSpacing: '0.5px',
        },
      },

      [`${componentCls}-body`]: {
        background: 'transparent',
      },
    },
  }
})
